<template>
    <front-layout title="Código de Conduta">
      <div class="bg-texture">
            <div class="container px-4 pt-60 pb-40 mx-auto">
                <div class="flex flex-col lg:flex-row items-center lg:space-x-12 text-center relative">
                    <div class="flex-1 relative">
                        <img src="/images/cod_conduta.png" alt="codigo de conduta">
                    </div>

                    <div class="flex-1 text-left relative">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div class="bg-white inline-block p-2 rounded-lg" id="cod_conduta" v-html="cod_conduta" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText"></div>

                        <div v-html="cod_conduta" v-else></div>

                        <a href="https://pessoalform.pt/cod_conduta.pdf" class="group text-xs text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Código de Conduta <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
                    </div>
                </div>
            </div>
       </div>
    </front-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'
    import BgShape from '@/Components/BgShape'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            BgShape
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            cod_conduta: String
        },
        data() {
            return {
                enableEdit: false,
                form: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        methods: {
            updateText(e) {
                this.form.setting = e.target.id
                this.form.content = e.target.innerHTML,
                this.form.route = this.route().current()
            },
            updateSettings(e) {
                if(this.form.setting != '' && this.form.content != '' & this.form.route != '') {
                    this.form.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        },
    })
</script>
